import { UserCircle } from 'lucide-react';
import FormField from '../ui/FormField';

const MIN_PROMPT_CHARS = 10;

/**
 * Valida prompt (mínimo de caracteres).
 * Ponto de integração: validação mais rica no backend.
 */
export function validatePrompt(value) {
  const trimmed = (value || '').trim();
  return trimmed.length >= MIN_PROMPT_CHARS;
}

/**
 * Formulário de personalidade do agente: nome público e prompt principal.
 * onChange já chama updateAgent (injetado pelo container).
 *
 * @param {Object} props
 * @param {{ publicName: string, prompt: string }} props.agent
 * @param {(updates: { publicName?: string, prompt?: string }) => void} props.onUpdate
 */
export default function AgentPersonalityForm({ agent, onUpdate }) {
  const promptValid = validatePrompt(agent.prompt);
  const promptError = agent.prompt && agent.prompt.trim().length > 0 && !promptValid;

  return (
    <div className="bg-appSurface p-8 rounded-3xl border border-appSurfaceBorder shadow-sm space-y-6">
      <h3 className="text-xs font-black text-appText uppercase tracking-widest flex items-center gap-2">
        <UserCircle size={16} className="text-appPrimary" /> Personalidade
      </h3>

      <FormField label="Nome Público" id="agent-public-name">
        <input
          id="agent-public-name"
          type="text"
          value={agent.publicName || ''}
          onChange={(e) => onUpdate({ publicName: e.target.value })}
          className="w-full bg-appSurfaceBorder/20 border-none rounded-xl p-3 text-sm font-bold text-appPrimary focus:ring-2 focus:ring-appPrimary outline-none"
          aria-invalid={false}
        />
      </FormField>

      <FormField label="Instruções Principais (Prompt)" id="agent-prompt">
        <textarea
          id="agent-prompt"
          value={agent.prompt || ''}
          onChange={(e) => onUpdate({ prompt: e.target.value })}
          placeholder={`Mínimo ${MIN_PROMPT_CHARS} caracteres...`}
          className={`w-full bg-appSurfaceBorder/20 border-none rounded-2xl p-4 text-sm italic h-40 focus:ring-2 focus:ring-appPrimary resize-none leading-relaxed outline-none ${
            promptError ? 'ring-2 ring-red-300' : ''
          }`}
          aria-invalid={promptError}
          aria-describedby={promptError ? 'prompt-error' : undefined}
        />
        {promptError && (
          <p id="prompt-error" className="text-xs text-red-600 mt-1 ml-1">
            O prompt deve ter pelo menos {MIN_PROMPT_CHARS} caracteres.
          </p>
        )}
      </FormField>
    </div>
  );
}
